import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Link from "@amzn/meridian/esm/components/link";
import Divider from "@amzn/meridian/esm/components/divider";
import Theme from "@amzn/meridian/esm/components/theme";
import Tile from "@amzn/meridian/esm/components/tile";
import { openUrl } from "../../../utils/zoomSdkUtils";
import { PHONE_TOOL_USER_BASE, PILL_RADIUS_FILL } from "../../../constants";
import { THEME_COLOR } from "../../../styles/colors";
import InsightSlot from "./InsightSlot";
import ProfilePhoto from "../ProfilePhoto";

// TODO(MEETEX-299408): Delete this V1 rollback component after Who's Who V2 rollout.
const LegacyInviteeCard = ({ person, isError, accentColor }) => {
  const isExternal = person.external;
  const dash = "—";
  const showField = (value) => (isError ? dash : value || dash);
  const phoneToolUrl = `${PHONE_TOOL_USER_BASE}${person.alias}`;

  return (
    <Tile accent={accentColor} accentPosition="start" spacingInset="400">
      <Row spacing="400" alignmentVertical="top">
        {!isError && (
          <Column spacing="100" alignmentHorizontal="center">
            <ProfilePhoto alias={person.alias} initials={person.initials} hasPhoto={person.hasPhoto} />
            {!isExternal && person.alias && (
              <Text type="b100" color="secondary">{person.alias}</Text>
            )}
          </Column>
        )}
        <Column spacing="200" width="fill">
          <Row spacing="200" alignmentVertical="center" wrap="down">
            {!isExternal && !isError && person.alias ? (
              <Link onClick={() => openUrl(phoneToolUrl)} type="primary">
                <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
                  <Text type="h50">{person.name}</Text>
                </Theme>
              </Link>
            ) : (
              <Text type="h50">{person.name}</Text>
            )}
            {!isExternal && (
              <Text type="b100" color="secondary">· {showField(person.level)}</Text>
            )}
            {person.isYou && (
              <Theme tokens={{ boxBorderRadiusFill: PILL_RADIUS_FILL }}>
                <Box type="fill" backgroundColor={THEME_COLOR.LIGHT_LAVENDER} spacingInset="none 200">
                  <Text type="b100" color="secondary">YOU</Text>
                </Box>
              </Theme>
            )}
          </Row>

          <Row spacing="200" alignmentVertical="center" wrap="down">
            <Theme tokens={{ textColorPrimary: THEME_COLOR.CHARCOAL_GRAY }}>
              <Text type="b100" color="primary">
                <strong>{isExternal ? "External" : showField(person.role)}</strong>
              </Text>
            </Theme>
            <Text type="b100" color="secondary">
              {isExternal ? (person.email || dash) : showField(person.org)}
            </Text>
          </Row>

          {!isError && !person.isYou && (
            <Box spacingInset="300 none">
              <Divider />
            </Box>
          )}

          {!isError && !person.isYou && (
            <InsightSlot insight={person.insight} />
          )}

          {!person.isYou && (
            <Text type="b100" color="secondary">
              {isError || isExternal
                ? dash
                : person.metBeforeCount > 0
                  ? `• Met before · ${person.metBeforeCount} meeting${person.metBeforeCount === 1 ? "" : "s"}`
                  : "• First meeting together"}
            </Text>
          )}
        </Column>
      </Row>
    </Tile>
  );
};

export default LegacyInviteeCard;
